"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.is = void 0;
var is = {
  obj: function obj(a) {
    return !!a && a !== '[object Object]' && a.toString() === '[object Object]';
  },
  fnc: function fnc(a) {
    return typeof a === 'function';
  }
};
exports.is = is;